import { Pipe, PipeTransform } from '@angular/core';
@Pipe({
  name: 'menufilter',
  pure:true
})
export class MenufilterPipe implements PipeTransform {
  transform(items: any[], modulename: string,formId:string,type:string): any {
    if (!items || !modulename) {
        return items;
    }
    
   
    if(type=="Main Menu")
    {
    return items.filter(item => item.ModuleName === modulename && item.FormId != '');
    }
    if(type=="Child Menu")
    {
      return items.filter((item) => item.ModuleName === modulename && item.SubFormId === formId);
    }
}

}
